module.exports = __webpack_public_path__ + "star-twilight-red.0df1158fcd8e18439267.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/star-twilight-red.svg
// module id = ../../../../../src/assets/img/star-twilight-red.svg
// module chunks = main